import React from 'react';
import Card from 'react-bootstrap/Card';
import { Container, Row, Col, Spinner } from 'react-bootstrap';

function SpinnerCard() {

    return (
        <Card className="spinner-card">
            <Card.Body>
                <Container>
                    <Row>
                        <Col></Col>
                        <Col className="d-flex justify-content-center"><Spinner animation="border" variant="main" /></Col>
                        <Col></Col>
                    </Row>
                </Container>
            </Card.Body >
        </Card >
    );

}

export default SpinnerCard;